export enum PresignedUrlType {
  TRAINING = 'training',
  INDEX_FILE = 'index-file'
}
